<template>
  <div class="table-crud-modal" ref="addModal">
    <h2 class="lvl2-heading">Ajouter une vidéo</h2>
    <el-form
      ref="addVideoForm"
      :model="params"
      label-position="left"
      :status-icon="true"
      :rules="rules"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="title">
            <span>Titre:*</span>
            <el-input v-model="params.title" placeholder="Titre"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="type_supports">
            <span>{{ supportstypes.data.placeholder }}:*</span>
            <el-select
              no-data-text="..."
              popper-class="supports-f"
              v-model="params.type_supports"
              :placeholder="supportstypes.data.placeholder"
              filterable
              multiple
            >
              <el-option
                v-for="sup in supportstypes.data.options"
                :key="`sup__f-${sup.id}`"
                :label="sup.name"
                :value="sup.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="brand_id">
            <span>Marque:*</span>
            <el-select
              no-data-text="..."
              popper-class="brands-f"
              v-model="params.brand_id"
              placeholder="Marques"
              filterable
            >
              <el-option
                v-for="marque in marques.data.options"
                :key="`theme__f-${marque.id}`"
                :label="marque.name"
                :value="marque.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="theme_id">
            <span>Thématique:*</span>

            <el-select
              no-data-text="..."
              popper-class="themes-f"
              v-model="params.theme_id"
              placeholder="Thématiques"
              filterable
            >
              <el-option
                v-for="theme in thematiques.data.options"
                :key="`theme__f-${theme.id}`"
                :label="theme.name"
                :value="theme.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="freelancer_id">
            <span>Freelancer:</span>
            <el-select
              no-data-text="..."
              popper-class="freelancers-f"
              v-model="params.freelancer_id"
              placeholder="Freelancers"
              filterable
            >
              <el-option
                v-for="freelance in freelancers"
                :key="`theme__f-${freelance.id}`"
                :label="freelance.full_name"
                :value="freelance.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="status">
            <span>Status:*</span>
            <el-select
              no-data-text="..."
              popper-class="status-f"
              v-model="params.status"
              placeholder="Status"
            >
              <el-option
                v-for="status in statuses"
                :key="`status__f-${status.value}`"
                :label="status.label"
                :value="status.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="media">
            <span>Vidéo:</span>
            <FileUpload
              name="media-upload"
              :error="mediaEmpty"
              placeholder="Média"
              :acceptedTypes="['video/mp4']"
              @file-upload="params.media = $event"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="thumbnail">
            <span>Thumbnail:</span>
            <FileUpload
              name="thumbnail-upload"
              placeholder="Thumbnail"
              :error="thumbnailEmpty"
              :acceptedTypes="['image/png', 'image/jpeg', 'image/jpg']"
              @file-upload="params.thumbnail = $event"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="competitor_price">
            <span>Prix du concurrent:</span>
            <el-input
              v-model="params.competitor_price"
              :min="0"
              :controls="false"
              @input="handleCompetitorPriceChange"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="ean">
            <span>EAN:</span>
            <el-input v-model="params.ean" placeholder="EAN"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item prop="description">
            <span>description:</span>
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              v-model="params.description"
              placeholder="description"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item style="text-align: right">
        <base-button @click.prevent.stop.native="handleSubmit" :fluid="false"
          >Ajouter</base-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  Input,
  Select,
  Option,
  Form,
  FormItem,
  Message,
  Row,
  Col
} from "element-ui"
import { mapState } from "vuex"
import FileUpload from "@/components/FileUpload.vue"
import { addNewVideo } from "@/api/videos"
import { fetchUsers } from "@/api/users"
// import Checkbox from "@/components/Checkbox_Improved"
import { emitter } from "@/utils"
import { loaderMixin } from "@/mixins"
export default {
  components: {
    ElInput: Input,
    ElSelect: Select,
    ElOption: Option,
    ElFormItem: FormItem,
    ElForm: Form,
    ElRow: Row,
    ElCol: Col,
    FileUpload
    // Checkbox
  },
  mixins: [loaderMixin],
  data() {
    var validateSupport = (rule, value, callback) => {
      if (this.params.type_supports.length < 1) {
        callback(new Error("Le support est obligatoire"))
      } else {
        callback()
      }
    }
    var validateBrand = (rule, value, callback) => {
      if (!this.params.brand_id) {
        callback(new Error("La marque est obligatoire"))
      } else {
        callback()
      }
    }
    var validateTheme = (rule, value, callback) => {
      if (!this.params.theme_id) {
        callback(new Error("La Thématique est obligatoire"))
      } else {
        callback()
      }
    }
    var validateFreelancer = (rule, value, callback) => {
      /*if (!this.params.freelancer_id) {
        callback(new Error("Le freelancer est obligatoire"))
      } else {
        callback()
      }*/
      callback()
    }
    return {
      params: {
        theme_id: null,
        type_supports: null,
        brand_id: null,
        title: null,
        media: null,
        thumbnail: null,
        freelancer_id: null,
        status: "created",
        competitor_price: 0,
        ean: "",
        description: "",
        trending: 0
      },
      freelancers: [],
      statuses: [
        { label: "Créée", value: "created" },
        { label: "Validée", value: "approved" },
        { label: "Vérifiée", value: "verified" },
        { label: "Désactivée", value: "deactivated" }
      ],
      mediaEmpty: false,
      thumbnailEmpty: false,
      rules: {
        title: [
          {
            required: true,
            message: "Le titre est obligatoire",
            trigger: "blur"
          }
        ],
        type_supports: [{ trigger: "blur", validator: validateSupport }],
        brand_id: [{ trigger: "blur", validator: validateBrand }],
        theme_id: [{ trigger: "blur", validator: validateTheme }],
        freelancer: [{ trigger: "blur", validator: validateFreelancer }]
      }
    }
  },
  computed: {
    ...mapState({
      supportstypes: state => state.supportstypes,
      marques: state => state.marques,
      thematiques: state => state.thematiques
    })
  },
  methods: {
    handleSubmit() {
      this.$refs["addVideoForm"].validate(valid => {
        if (valid) {
          const { media, thumbnail, ...params } = this.params
          /*
          if (!thumbnail) {
            this.thumbnailEmpty = true;
            Message.error("Veuillez télécharger une miniature");
            return;
          }
          */

          /* if (!media) {
            this.mediaEmpty = true
            Message.error("Veuillez télécharger une video")
            return
          }*/
          this.openLoader(this.$refs.addModal)

          const formData = new FormData()
          if (this.params.media) {
            // Don't send media if null
            formData.append("media", media)
          }
          if (thumbnail) formData.append("thumbnail", thumbnail)

          addNewVideo(params, formData)
            .then(() => {
              Message.success("Vidéo ajoutée")
              emitter.$emit("update-table")
              this.closeLoader()
              this.$store.dispatch("closeModal")
            })
            .catch(() => {
              this.closeLoader()
              /* for (let key in response.data.errors) {
                Message.error(response.data.errors[key][0])
              } */
              // Message.error("Vidéo n'est pas ajoutée");
            })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleCompetitorPriceChange() {
      this.params.competitor_price = this.params.competitor_price
        .replace(/,/g, ".")
        .toString()
    }
  },
  created() {
    fetchUsers({ role: "freelancer" }).then(({ data }) => {
      //only get freelancers
      this.freelancers = data
    })
  }
}
</script>
